import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IVehicle } from '@okcargo-apps/shared-domain';
import { VehicleEditModalComponent } from '../vehicle-edit-modal/vehicle-edit-modal.component';

@Component({
  selector: 'lib-vehicle-edit-action',
  templateUrl: './vehicle-edit-action.component.html',
  styleUrls: ['./vehicle-edit-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton, IonIcon, TranslateModule],
})
export class VehicleEditActionComponent {
  public readonly vehicle = input.required<IVehicle>();

  private readonly modalCtrl = inject(ModalController);

  public async openEditModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: VehicleEditModalComponent,
      componentProps: { vehicle: this.vehicle() },
      backdropDismiss: false,
    });

    await modal.present();
  }
}
